import { styled } from '@mui/material'
import { Highlight } from 'entities/Documents'
import { useRef } from 'react'

import Highlights from './Highlights'

const Container = styled('div')(({ theme }) => ({
  position: 'relative',
  '& + &': {
    marginTop: theme.spacing(5),
  },
}))
const Img = styled('img')({
  pointerEvents: 'none',
})

type Props = {
  src: string
  highlights: Highlight[]
  ocrServiceId: number
}

const Page = ({ src, highlights, ocrServiceId }: Props) => {
  const imgRef = useRef<HTMLImageElement>(null)

  return (
    <Container style={{ width: imgRef.current?.width, height: imgRef.current?.height }}>
      <Img alt="" src={src} ref={imgRef} />
      <Highlights
        imgSize={imgRef.current?.width}
        highlights={highlights}
        ocrServiceId={ocrServiceId}
      />
    </Container>
  )
}

export default Page
